import logo from '../../assets/images/Isologo_blanco.png';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Menu,
  MenuItem
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Inventory,
  Build as InstallationIcon,
  Receipt,
  AccountCircle,
  ExitToApp,
  CloudSync as SyncIcon,
  People,
  Menu as MenuIcon,
  Calculate as CalculateIcon
} from '@mui/icons-material';
import { useAuth } from '../../context/AuthContext';

export const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [mainMenuAnchorEl, setMainMenuAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };


  const handleMainMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMainMenuAnchorEl(event.currentTarget);
  };

  const handleMainMenuClose = () => {
    setMainMenuAnchorEl(null);
  };

  const handleNavigate = (path: string) => {
    navigate(path);
    handleMainMenuClose();
  };

  const handleLogout = () => {
    logout();
    handleMenuClose();
  };

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  return (
    <AppBar position="sticky" elevation={1}>
      <Toolbar sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
        {/* Menú hamburguesa y logo juntos a la izquierda */}
        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleMainMenuOpen}
            sx={{ mr: 1 }}
          >
            <MenuIcon />
          </IconButton>
          <Box
            component="img"
            src={logo}
            alt="Logo LifeCycle"
            sx={{
              height: 38,
              maxWidth: 140,
              ml: 1,
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </Box>

        {/* Título perfectamente centrado con posición absoluta */}
        <Box sx={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, pointerEvents: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <Typography
            variant="h6"
            component="div"
            sx={{ cursor: 'pointer', fontWeight: 600, pointerEvents: 'auto' }}
            onClick={() => navigate('/dashboard')}
          >
            Presupuestador LifeCycle
          </Typography>
        </Box>

        {/* Usuario y menú a la derecha */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" sx={{ mr: 1 }}>
            {user?.name || user?.email}
          </Typography>
          <IconButton
            color="inherit"
            onClick={handleMenuOpen}
            size="large"
          >
            <AccountCircle />
          </IconButton>
        </Box>

        {/* Menú de Usuario */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem onClick={handleLogout}>
            <ExitToApp sx={{ mr: 1 }} />
            Cerrar Sesión
          </MenuItem>
        </Menu>

        {/* Menú Principal */}
        <Menu
          anchorEl={mainMenuAnchorEl}
          open={Boolean(mainMenuAnchorEl)}
          onClose={handleMainMenuClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <MenuItem 
            onClick={() => handleNavigate('/dashboard')}
            selected={isActive('/dashboard')}
          >
            <DashboardIcon sx={{ mr: 1 }} />
            Inicio
          </MenuItem>
          <MenuItem 
            onClick={() => handleNavigate('/budgets')}
            selected={isActive('/budgets')}
          >
            <Receipt sx={{ mr: 1 }} />
            Presupuestos
          </MenuItem>
          <MenuItem 
            onClick={() => handleNavigate('/products')}
            selected={isActive('/products')}
          >
            <Inventory sx={{ mr: 1 }} />
            Stock
          </MenuItem>
          <MenuItem 
            onClick={() => handleNavigate('/installations')}
            selected={isActive('/installations')}
          >
            <InstallationIcon sx={{ mr: 1 }} />
            Instalaciones
          </MenuItem>
          {user?.role === 'admin' && (
            <MenuItem 
              onClick={() => handleNavigate('/integration/google-sheets')}
              selected={isActive('/integration')}
            >
              <SyncIcon sx={{ mr: 1 }} />
              Google Sheets
            </MenuItem>
          )}
          <MenuItem 
            onClick={() => handleNavigate('/calculadora')}
            selected={isActive('/calculadora')}
          >
            <CalculateIcon sx={{ mr: 1 }} />
            Calculadora
          </MenuItem>
          {user?.role === 'admin' && (
            <MenuItem
              onClick={() => handleNavigate('/admin/users')}
              selected={isActive('/admin/users')}
            >
              <People sx={{ mr: 1 }} />
              Gestión de Usuarios
            </MenuItem>
          )}
        </Menu>

  {/* Menú de Administración eliminado: ahora el acceso es directo desde el menú principal para admin */}
      </Toolbar>
    </AppBar>
  );
};
